import { useEffect } from "react";
import ApiManager from "./apiManager";
import { withCookies } from "react-cookie";
import SimpleCrypto from "simple-crypto-js";
import config from "./baseConfig";
import { localStorageGetItem } from "./storage";

const ChatSDK = (props) => {
  const { allCookies } = props;
  const loginToken = allCookies.loginToken;

  const getDecryptedToken = () => {
    const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
    return simpleCrypto.decrypt(loginToken);
  };

  const currentLng = localStorageGetItem("defaultLngPrefix") || "en";

  const urlPerLng = config.chatBotIds;
  useEffect(() => {
    if (!loginToken) {
      const existingScript = document.getElementById("TSChatSDK");
      const chatSDKWrapper = document.getElementById("ts-chatbot-wrapper");

      if (chatSDKWrapper) {
        document.body.removeChild(chatSDKWrapper);
      }
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
      return;
    }

    const existingScript = document.getElementById("TSChatSDK");
    const chatSDKWrapper = document.getElementById("ts-chatbot-wrapper");
    if (chatSDKWrapper) {
      document.body.removeChild(chatSDKWrapper);
    }
    if (existingScript) {
      document.body.removeChild(existingScript);
    }

    const script = document.createElement("script");
    script.id = "TSChatSDK";
    script.type = "text/javascript";
    script.async = true;

    ApiManager.getRequest(
      { jwt: getDecryptedToken() },
      "/account?bonus=1"
    ).then((res) => {
      if (res.status === 200) {
        const username = res?.data?.data?.encryptedNumber;
        script.src = `${urlPerLng[currentLng]}&username=${username}`;

        document.body.appendChild(script);
      } else {
        script.src = `${urlPerLng[currentLng]}&username`;
        document.body.appendChild(script);
      }
    });

    return () => {
      const existingScript = document.getElementById("TSChatSDK");
      const chatSDKWrapper = document.getElementById("ts-chatbot-wrapper");
      if (chatSDKWrapper) {
        document.body.removeChild(chatSDKWrapper);
      }
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [loginToken, currentLng]);

  return null;
};

export default withCookies(ChatSDK);